// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2rgIs","footer":"Form_footer__2HaTY"};